import React, { useEffect } from 'react';

/**
 * Meta Pixel base code — 52 Weeks of Speaking.
 * Single source of truth for the pixel id: this is the only pixel on the page,
 * the only place it is initialised, and the guards below keep PageView from
 * firing twice.
 *
 * Note: no <noscript> fallback image is injected. Creating an <img> with JS
 * makes the browser request it immediately, which sent a second PageView.
 * A noscript fallback is pointless anyway, since this code only runs with JS.
 */
const PIXEL_ID = '2329477784473557';
type FbqWindow = Window & {
  fbq?: unknown;
  __metaPixelInjected?: boolean;
};
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || !PIXEL_ID) return;
    const w = window as FbqWindow;
    if (w.__metaPixelInjected || w.fbq) return;
    w.__metaPixelInjected = true;
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`;
    document.head.appendChild(script);
  }, []);
  return null;
}